import { render, staticRenderFns } from "./r-cell-config-dialog.vue?vue&type=template&id=54581cc8&scoped=true"
import script from "./r-cell-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-cell-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-cell-config-dialog.vue?vue&type=style&index=0&id=54581cc8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54581cc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54581cc8')) {
      api.createRecord('54581cc8', component.options)
    } else {
      api.reload('54581cc8', component.options)
    }
    module.hot.accept("./r-cell-config-dialog.vue?vue&type=template&id=54581cc8&scoped=true", function () {
      api.rerender('54581cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/cells/r-cell-config-dialog.vue"
export default component.exports